import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const options = {
  theme: {
    light: true,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#094547',
        secondary: '#035f64',
        description: '#7C8DB5',
        info: '#0085FF',
        success: '#34C759',
        warning: '#eab308',
        error: '#FF3B30',
        border: '#DBDBDB',
        foreground: '#687076',
        background: '#f8f9fa',
        backgroundPrimary: '#eefff5',
      },
    },
  },
};

export default new Vuetify(options);
